// This file was automatically generated from appchart.dialog.ordermed.fulfillRx.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.ordermed.fulfillRx');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.render.header');
goog.require('el8.template.render.medOrder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.fulfillRx.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="el8BgGrayLight pad10 padt20"><div class="practice-header-container"></div></div><div class="overlayContainer">');
  el8.template.appchart.dialog.ordermed.fulfillRx.set(opt_data.set, output);
  output.append('<div class="el8Wrap"><span class="pharmacy-info"><a class="change-pharmacy el8Link">Select Pharmacy</a></span></div><div class="spacer5"><p class="el8AppColor">Note: No pharmacy required if you wish to print the prescription(s) instead of ePrescribing.</p></div></div><div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.fulfillRx.set = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.controlled.length > 0) {
    output.append('<h2 class="orderTitle">Controlled Substance</h2>', (! el8Globals.FEATURES.MDToolboxEPCS) ? '<div class="el8NotificationCaution"><p>Note: Controlled Substances will not be sent electronically to the pharmacy.</p></div>' : '');
    el8.template.render.header.patientOrder(opt_data.patient, output);
    var controlledRxList1866 = opt_data.controlled;
    var controlledRxListLen1866 = controlledRxList1866.length;
    for (var controlledRxIndex1866 = 0; controlledRxIndex1866 < controlledRxListLen1866; controlledRxIndex1866++) {
      var controlledRxData1866 = controlledRxList1866[controlledRxIndex1866];
      el8.template.render.medOrder.prescription(soy.$$augmentData(controlledRxData1866, {deniedRefillRequest: opt_data.deniedRefillRequest, index: controlledRxIndex1866 + 1, renewalReason: opt_data.denialReason}), output);
    }
    el8.template.render.medOrder.signature(opt_data, output);
    output.append('<div class="spacer"></div>');
  }
  if (opt_data.prescriptions.length > 0) {
    output.append('<h2 class="orderTitle">Prescription</h2>');
    el8.template.render.header.patientOrder(opt_data.patient, output);
    var prescriptionList1878 = opt_data.prescriptions;
    var prescriptionListLen1878 = prescriptionList1878.length;
    for (var prescriptionIndex1878 = 0; prescriptionIndex1878 < prescriptionListLen1878; prescriptionIndex1878++) {
      var prescriptionData1878 = prescriptionList1878[prescriptionIndex1878];
      el8.template.render.medOrder.prescription(soy.$$augmentData(prescriptionData1878, {deniedRefillRequest: opt_data.deniedRefillRequest, index: prescriptionIndex1878 + 1, replaceReason: opt_data.denialReason}), output);
    }
    el8.template.render.medOrder.signature(opt_data, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.fulfillRx.pharmacy = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8AppColor">For ePrescribing, prescription will be electronically sent to the following pharmacy:</p>');
  el8.template.render.medOrder.pharmacy(soy.$$augmentData(opt_data.pharmacy, {canChange: opt_data.canChange}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.fulfillRx.noPharmacy = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('\t<a class="change-pharmacy el8Link">Select pharmacy</a>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.fulfillRx.erxConfirmationPracticeHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="service-location-form el8BgGrayLight"><div class="el8FieldSection"><div class="confirm-msg fr el8AlignRight el8StandardFontSize el8Bold"></div><div class="el8Offset el8OffsetSmall"><label class="el8label el8OffsetLabel el8OffsetSmall">Prescriber Location</label><select name="eRxServiceLocation" class="w65">');
  var serviceLocationList1893 = opt_data.serviceLocations;
  var serviceLocationListLen1893 = serviceLocationList1893.length;
  for (var serviceLocationIndex1893 = 0; serviceLocationIndex1893 < serviceLocationListLen1893; serviceLocationIndex1893++) {
    var serviceLocationData1893 = serviceLocationList1893[serviceLocationIndex1893];
    output.append('<option value="', soy.$$escapeHtml(serviceLocationData1893.id), '">', soy.$$escapeHtml(serviceLocationData1893.name), '</option>');
  }
  output.append('</select><span class="padl10"><a class="erx-service-location-default el8Link">edit default location</a></span><div class="erx-service-location-detail pad5 el8FontSmall"></div></div></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.fulfillRx.erxConfirmationPracticeHeaderServiceLocation = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<b>', soy.$$escapeHtml(opt_data.serviceLocation.name), '</b><br>', soy.$$escapeHtml(opt_data.serviceLocation.addressLine), '<br>', soy.$$escapeHtml(opt_data.serviceLocation.cityStateZip), (opt_data.serviceLocation.phone || opt_data.serviceLocation.fax) ? '<br>' + ((opt_data.serviceLocation.phone) ? 'P: ' + soy.$$escapeHtml(opt_data.serviceLocation.phone) : '') + ((opt_data.serviceLocation.phone && opt_data.serviceLocation.fax) ? ' | ' : '') + ((opt_data.serviceLocation.fax) ? 'F: ' + soy.$$escapeHtml(opt_data.serviceLocation.fax) : '') : '');
  if (!opt_sb) return output.toString();
};
